import { REFERRAL_CODE_QUERY_PARAM_NAME } from 'routes/constants';

import { removeQueryParamsFromURL } from 'modules/common/utils/removeQueryParamsFromURL';

export const removeReferralCodeFromUrl = () => {
  removeQueryParamsFromURL({ queryParamName: REFERRAL_CODE_QUERY_PARAM_NAME });
};
